<div class="flex gap-2">
	<app-icon
		[icon]="ICON.FILE_INVOICE_DOLLAR"
		class="text-green text-2xl"
	></app-icon>
	<div>
		<div class="flex items-end gap-2">
			<div>
				<p class="text-gray text-sm">Purchase price (title insurance only)</p>
				<p class="font-bold">
					{{ getTitleInsuranceResolvedPurchasePrice_() | centsToDollars }}
				</p>
			</div>
			<app-anchor
				[icon]="ICON.EDIT"
				type="static"
				(click)="openModal()"
			></app-anchor>
		</div>
	</div>
</div>
